// client/marks/font-size.ts
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/fonts/fonts";
import { FONT_SIZE_KEY, FONT_SIZE_SCHEMA } from "../../schema/marks/font-size.js";
import { toggleMark } from "../helper/toggleMark.js";
import { MenuItemGroup } from "../types.js";
import { isInText } from "../util.js";
var fontSize = () => ({
  mark: {
    name: FONT_SIZE_KEY,
    schema: FONT_SIZE_SCHEMA()
  },
  menuItems: [
    // createFontSizeMenuItem('8px'),
    // createFontSizeMenuItem('12px'),
    // createFontSizeMenuItem('16px'),
    // createFontSizeMenuItem('20px'),
    // createFontSizeMenuItem('24px'),
  ]
});
var FONT_SIZE_MENU_ITEM = (fontSize2) => createFontSizeMenuItem(fontSize2);
function createFontSizeMenuItem(fontSize2) {
  return {
    group: MenuItemGroup.TEXT_STYLE,
    label: fontSize2,
    run: (view) => {
      toggleMark({ markName: FONT_SIZE_KEY, view, attrs: { fontSize: fontSize2 } })(view.state, view.dispatch);
    },
    shouldVisualize: (view) => {
      return isInText(view.state);
    },
    isActive: (view) => {
      return toggleMark({ markName: FONT_SIZE_KEY, view, attrs: { fontSize: fontSize2 } })(view.state);
    }
  };
}
export {
  FONT_SIZE_MENU_ITEM,
  createFontSizeMenuItem,
  fontSize
};
